import { render } from "./BackButtonHeader.vue?vue&type=template&id=dfadef6a&scoped=true"
import script from "./BackButtonHeader.vue?vue&type=script&lang=js"
export * from "./BackButtonHeader.vue?vue&type=script&lang=js"

import "./BackButtonHeader.vue?vue&type=style&index=0&id=dfadef6a&scoped=true&lang=css"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfadef6a"]])

export default __exports__